<script>
import FullCalendar from '@fullcalendar/vue'

import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import Datepicker from 'vuejs-datepicker';
import RoomDetails from './RoomDetails'
import moduleAnnualPlan from "@/store/annualPlan/moduleAnnualPlan.js";
import moduleHoliday from "@/store/holiday/moduleHoliday.js";
import AnnualPlanSearchSidebar from './AnnualPlanSearchSidebar.vue'
import moduleCourseCategory from "@/store/settings/courseCategory/moduleCourseCategory.js";
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";
import moduleCourseAreaOfStudy from "@/store/settings/courseAreaOfStudy/moduleCourseAreaOfStudy.js";
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    RoomDetails,
    Datepicker,
    AnnualPlanSearchSidebar,
  },
  data() {
    return {
      calendarPlugins: [ dayGridPlugin,listPlugin, timeGridPlugin, interactionPlugin ],
     confirmPeriod:{},
     format:"dd-MM-yyyy",
      // slot details (sidebar)
      addNewDataSidebar: false,
      sidebarData: {},
      rowDataForDelete: {},
      activeConfirm: false,
      firstTime:true,
      itemsPerPage: 10,
      selected: [],
      currentItemView: 'item-grid-view',
     showSearchSidebar: false,
     search:{},
     event:{},
     isMounted:false,
     showTable:true,
    }
  },

   methods:{

    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
     addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    CloseSidebar(event) {
      console.log(event);
      if(event!=undefined)
      {

            this.$refs.fullCalendar.$emit("addEvent",event);
            this.$refs.fullCalendar.$emit('refetch-events')
      }
      this.addNewDataSidebar = false;
    },

    handleDateClick(arg) {
      this.sidebarData.StartDate = arg.date;
      debugger
      this.toggleDataSidebar(true);
    },
    handleDateSelect(arg) {
      this.sidebarData={};
        this.sidebarData.StartDate = arg.start;
          this.sidebarData.EndDate = arg.end;
          debugger
      this.toggleDataSidebar(true);
    },

    eventClick(arg)
    {
      debugger ;
       this.sidebarData.StartDate = arg.event.start;
       this.sidebarData.EndDate = arg.event.end;
       this.sidebarData.ID = arg.event.extendedProps.ID;
       this.sidebarData.ClassNo = arg.event.extendedProps.ClassNo;
       this.sidebarData.ClassRoomName = arg.event.extendedProps.ClassRoom.Name;
       this.sidebarData.CourseID = arg.event.extendedProps.CourseID;
         this.sidebarData.CourseName = arg.event.extendedProps.Course.Name;
       this.sidebarData.CourseClassInstructors=arg.event.extendedProps.CourseClassInstructors;

       this.toggleDataSidebar(true);
    },

  toggleSearchSidebar(val = false) {
      debugger
      this.showSearchSidebar = val;
    },

  closeSearchSidebar(search) {
    debugger
    if(search)
    {
       this.searchRoomPlan();
    }

     this.showSearchSidebar = false;
    },

     searchRoomPlan(){
       debugger;
         this.$store.dispatch("courseClassList/SearchCourseClassForRoom",  this.search).catch(err => {
                  console.error(err);
                });


    },

    formatJsDate(dateToFormat)
    {
         return dateToFormat.getFullYear()+"-"+ (dateToFormat.getMonth()+1)+"-"+dateToFormat.getDate();
    },

    handleMonthChange: function(arg)
    {

        var period={};
        period.start=this.formatJsDate(arg.view.activeStart);
        period.end=this.formatJsDate(arg.view.activeEnd);
        this.$store.dispatch("courseClassList/GetRoomPlanInPeriod",period).then(()=>{
          if(this.firstTime)
          {
              this.$refs.fullCalendar.getApi().next();
              this.$refs.fullCalendar.getApi().prev();
          }
          else
           this.$refs.fullCalendar.getApi().updateSize();
           this.firstTime=false;
        }).catch(err => {
          console.error(err);
        });
      },

      eventDrop(arg)
      {
          if(arg.event.extendedProps.isConfirmed)
          {
            arg.revert();
          }
          else
          {
              var obj= JSON.parse(JSON.stringify( arg.event.extendedProps)) ;
            obj.StartDate= arg.event.start;
            obj.EndDate=arg.event.end;
            obj.start= arg.event.start;
            obj.end=arg.event.end;
                this.$store.dispatch("annualPlanList/updateItem",  obj).catch(err => {
                  console.error(err);
                });
          }
      },

      eventResize(arg)
      {

        if(arg.event.extendedProps.isConfirmed)
             {
                arg.revert();
             }
             else
             {
               var obj= JSON.parse(JSON.stringify( arg.event.extendedProps)) ;
               obj.StartDate= arg.event.start;
               obj.EndDate=arg.event.end;
               obj.start= arg.event.start;
               obj.end=arg.event.end;
                  this.$store.dispatch("annualPlanList/updateItem", obj).catch(err => {
                    console.error(err);
                  });
             }
      },

       dayRender: function( obj ) {
          if(this.$store.state.holidayList.weekend.includes(obj.date.getDay()))
          {
             obj.el.bgColor="#f3f3f3";
          }
      },

        ConfirmEventMessage(event){
         this.event=event;

        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: this.$t("Confirm") ,
          text: this.$t("Areyousureyouwantconfirmthisevent")+"?",
          accept: this.ConfirmEvent
        });
      },

      ConfirmEvent() {
         this.event.title= this.event.title+" (Confirmed)";
          this.event.isConfirmed=true;
       this.$store.dispatch("annualPlanList/ConfirmEvent",  this.event).then(()=>{
          this.$refs.fullCalendar.getApi().next();
            this.$refs.fullCalendar.getApi().prev();
       }).catch(err => {
            console.error(err);
          });
      },

    },

   created() {
       if (!moduleHoliday.isRegistered) {
      this.$store.registerModule("holidayList", moduleHoliday);
      moduleHoliday.isRegistered = true;
    }
     this.$store.dispatch("holidayList/GetWeekend");

    if (!moduleAnnualPlan.isRegistered) {
      this.$store.registerModule("annualPlanList", moduleAnnualPlan);
      moduleAnnualPlan.isRegistered = true;
    }
     if (!moduleCourseCategory.isRegistered) {
      this.$store.registerModule("courseCategoryList", moduleCourseCategory);
      moduleCourseCategory.isRegistered = true;
    }
       if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
     if (!moduleCourseAreaOfStudy.isRegistered) {
      this.$store.registerModule("courseAreaOfStudyList", moduleCourseAreaOfStudy);
      moduleCourseAreaOfStudy.isRegistered = true;
    }
     if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
    this.$store.dispatch("languageList/fetchDataListItems");
    this.$store.dispatch("courseAreaOfStudyList/fetchDataListItems");
    this.$store.dispatch("industrySectorList/fetchDataListItems");
    this.$store.dispatch("courseCategoryList/fetchDataListItems");
      if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }
   //this.$store.dispatch("courseClassList/fetchDataListItems");
    //this.$store.dispatch("annualPlanList/fetchDataListItems");

    this.search.StartDate= new Date().getFullYear()+"/01/01";
    this.search.EndDate=new Date().getFullYear()+"/12/31";

    this.searchRoomPlan();
  },

  computed:{
    isConfirmFormValid(){
      return this.confirmPeriod.dateFrom&&this.confirmPeriod.dateTo;
    },
      events() {
        debugger;
        return this.$store.state.courseClassList.courseClass
      // return this.$store.state.annualPlanList.annualPlans;
    },
     currentPage() {
      if (this.isMounted) {
        this.showTable=false;
        return this.$refs.tableAnnualPlan.currentx;

      }
      return 0;
    },
 courseClass() {
      return this.$store.state.courseClassList.courseClass;
    },
    annualPlans() {
      return this.$store.state.annualPlanList.annualPlanList;
    }
  },
  mounted(){
    this.isMounted=true;
  }
}

</script>


<template>
  <div >
    <Room-details :isSidebarActive="addNewDataSidebar" @closeSidebar="CloseSidebar" :data="sidebarData" />
     <vx-card class="p-5  mb-5">
        <div class="vx-row">
        <!-- <label for="from" class="vs-input--label"> from</label>
        <datepicker :format="format" placeholder="from" v-model="confirmPeriod.dateFrom" class="vx-col lg:w-1/3 w-full" name="from" v-validate="'required'"></datepicker>
         <label for="to" class="vs-input--label"> to</label>
        <datepicker :format="format" placeholder="to" v-model="confirmPeriod.dateTo" class="vx-col lg:w-1/3 w-full" name="to" v-validate="'required'"></datepicker>
        <vs-button  class="mr-6" @click="confirmEventInPeriod" :disabled="!isConfirmFormValid">Confirm</vs-button> -->
          <div>
              <feather-icon
                  icon="CalendarIcon"
                  @click="currentItemView='item-grid-view'"
                  class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                  :svgClasses="{'text-primary stroke-current': currentItemView == 'item-grid-view'}" />
              <feather-icon
                  icon="ListIcon"
                  @click="currentItemView='item-list-view';"
                  class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                  :svgClasses="{'text-primary stroke-current': currentItemView == 'item-list-view'}" />
          </div>
        </div>
     </vx-card>
     <template v-if="currentItemView == 'item-grid-view'">
     <div class="vx-card">
    <FullCalendar defaultView="dayGridMonth"  @datesRender="handleMonthChange"  @eventClick="eventClick" ref="fullCalendar" selectable="true" :plugins="calendarPlugins" @dateClick="handleDateClick" @select="handleDateSelect"
   :events="this.$store.state.courseClassList.courseClass"
    editable="true" @eventDrop="eventDrop" @eventResize="eventResize"
     @dayRender="dayRender"
    :header="{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridYear,dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        }"
        />
     </div>
     </template >


     <div id="data-list-list-view" class="data-list-container">

         <template v-if="currentItemView == 'item-list-view'||showTable" >
           <div>
              <AnnualPlanSearchSidebar :data="'courseClass'" :isSidebarActive="showSearchSidebar" @closeSearchSidebar="closeSearchSidebar"  :search="search"/>
           </div>

            <vs-table ref="tableAnnualPlan" multiple v-model="selected" pagination :max-items="itemsPerPage" n :data="courseClass">

              <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
              <vs-button type="border" icon-pack="feather" icon="icon-search" @click="toggleSearchSidebar(true)">{{$t('Search')}}</vs-button>

                  <!-- ITEMS PER PAGE -->
                  <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                      <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ courseClass.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : courseClass.length }} of {{ courseClass.length }}</span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="itemsPerPage=4">
                        <span>4</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage=10">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage=20">
                        <span>20</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
              </div>

              <template slot="thead">
                  <vs-th sort-key="Course">{{$t('Room')}}</vs-th>
                  <vs-th sort-key="Course"> {{$t('CourseClassNo')}}</vs-th>
                <vs-th sort-key="Start">{{$t('Start')}}</vs-th>
                  <vs-th sort-key="End">{{$t('End')}}</vs-th>

              </template>

                <template slot-scope="{data}">
                  <tbody>

                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="product-name font-medium truncate">{{ tr.ClassRoom.Name }}</p>
                      </vs-td>
                     <vs-td>
                        <p class="product-name font-medium truncate">{{ tr.ClassNo}}</p>
                      </vs-td>
                      <vs-td>
                        <p class="product-name font-medium truncate">{{ tr.StartDate.split('T')[0]  }}</p>
                      </vs-td>
                      <vs-td>
                        <p class="product-name font-medium truncate">{{ tr.EndDate.split('T')[0]  }}</p>
                      </vs-td>


                    </vs-tr>
                  </tbody>
                </template>
            </vs-table>
         </template>

  </div>
  </div>
</template>

<style lang='scss'>

@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

</style>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
